import { PageType, reportWebAction, WebActionName } from "@snapchat/web-blizzard-reporting";
import { incrementCounter } from "@snapchat/web-graphene-reporting";
import { useCallback, useContext } from "react";
import { FormattedMessage } from "react-intl";
import { grafanaBasePrefix } from "../../../lib/grafana";
import styles from "./FindMoreLenses.module.css";
import { PageContext } from "@snapchat/web-frame";
import { SearchBar } from "@snapchat/web-search-bar";
import { ButtonColor, ColoredButton } from "@snapchat/web-sds-c";
import { getLocale } from "@snapchat/web-i18n";
const THUMBNAIL_PATH = `https://lens.snapchat.com/images/find-more-lenses`;
const THUMBNAILS = [
    `${THUMBNAIL_PATH}/lens-2.png`,
    `${THUMBNAIL_PATH}/lens-3.png`,
    `${THUMBNAIL_PATH}/lens-1.png`,
    `${THUMBNAIL_PATH}/lens-4.png`,
];
/* istanbul ignore next : Remove once test code is added */
export function measureExposure() {
    void incrementCounter(`${grafanaBasePrefix}.Experiment.FindMoreLenses.ExposureLogged`, 1);
}
export function FindMoreLenses({ thumbnailCount, isMobile }) {
    const { webClientId } = useContext(PageContext);
    /* istanbul ignore next: Remove once test code is added */
    const onFindMoreLensesClick = useCallback(() => {
        reportWebAction({
            pageType: PageType.LENS_PROFILE,
            actionName: WebActionName.FindMoreLensesClick,
            webClientId: webClientId ?? "",
        });
    }, [webClientId]);
    return (<div className={styles.container}>
      <div className={styles.thumbnails}>
        {THUMBNAILS.slice(0, thumbnailCount).map((src) => (<div key={src} className={styles.filterThumbnail}>
            {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
            <img src={src} alt="Filter Lens by Snapchat"/>
          </div>))}
      </div>

      <div className={styles.cta}>
        <p className={styles.ctaTitle}>
          <FormattedMessage description="Text prompting user to click the find more lenses button" defaultMessage="Find more Lenses and Filters"/>
        </p>
        {isMobile ? (<ColoredButton color={ButtonColor.BLUE} onClick={onFindMoreLensesClick} link="/">
            <FormattedMessage description="Title of the find more lenses button" defaultMessage="Lens Explorer"/>
          </ColoredButton>) : (<SearchBar pageType={PageType.LENS_PROFILE} localeProps={getLocale()} searchQuery=""/>)}
      </div>
    </div>);
}
